import { Container } from "@mui/material";
import PlusIcon from "assets/icons/PlusIcon";
import { SearchIcon2 } from "assets/icons/SearchIcon";
import BasicButton from "components/BasicInputs/BasicButton";
import { ArchiveSidebar } from "./ArchiveSidebar";

import useDocumentArchiveModel from "./document.view.model";
import FileUploadModal from "components/fileUploadModal/FileUploadModal";
import Table from "components/Table";
type PageHeaderProps = {
  pageTitle: string;
  pageDescription: string;
  onClick: () => void;
};
const PageHeader = ({ pageTitle, pageDescription, onClick }: PageHeaderProps) => {
  return (
    <div className="flex flex-row items-center w-full justify-between">
      <div className="flex flex-col  items-start flex-1">
        <span className="text-2xl font-IRANSansMedium font-medium text-dark-6">{pageTitle}</span>
        <span className="text-sm font-IRANSans font-normal text-[#8D8E8F] mt-3">{pageDescription}</span>
      </div>
      {/* <div className="flex flex-col items-end justify-center gap-3 ">
        <BasicButton variant="contained" onClick={onClick}>
          <PlusIcon color="#FFF" scale={0.7} />
          <span>افزودن فایل</span>
        </BasicButton>
      </div> */}
    </div>
  );
};

const DocumentArchive = () => {
  const {
    archiveSideBarItem,
    archiveLoading,
    activeArchive,
    setActiveArchive,
  } = useDocumentArchiveModel();

  return (
    <div className="container h-full ">
      <div className="flex flex-col   h-full py-8 px-4">
        <PageHeader
          pageTitle={"آرشیو اسناد"}
          pageDescription={"نمایش کالا و خدمات کسب و کار"}
          onClick={() => {}}
        />
        <div className="flex bg-white rounded-xl w-full flex-row py-6 px-8 h-full overflow-hidden my-12 gap-8">
          <ArchiveSidebar
            item={archiveSideBarItem}
            loading={archiveLoading}
            activeArchive={activeArchive}
            setActiveArchive={(v) => {
              setActiveArchive(v);
            }}
          />
          <div className="flex flex-1 flex-col overflow-y-auto border rounded-lg  ">
            <Table type="archive" style={{ margin: 0, padding: "0px" }} fetchOnPaginationChange={false} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentArchive;
